import { Button, Modal, ModalOverlay, ModalContent, ModalHeader, ModalCloseButton, ModalBody, ModalFooter, FormControl, FormLabel, NumberInputStepper, Stack, Select, NumberInput, NumberInputField, NumberIncrementStepper, NumberDecrementStepper } from "@chakra-ui/react";
import React, { useRef, useState } from "react";
import { getAPIEndpoint } from "views/config";
import axios from "axios";
import { logger } from "views/models/logging";
import { ToastContainer, toast } from 'react-toastify';

export function Topup({ isOpen = false, onClose = null, refreshData, clients = [], creator, authKey }) {
    const initialRef = useRef(null);
    const [client, setClient] = useState('');
    const [amount, setAmount] = useState();
    const [isLoading, setIsloading] = useState(false);

    const topUp = async () => {
        setIsloading(true);

        const params = {
            agentId: client,
            amount,
            creator
        };

        const apiHeader = {
            headers: {
                "authorization": `Bearer ${authKey}`
            }
        }

        try {
            const response = await axios.post(getAPIEndpoint('topup-hist'), params, apiHeader);
            if (response) {
                const { status, data } = response.data;
                if (status === 'success' && data) {
                    setIsloading(false);
                    refreshData(authKey);
                    clear();
                    onClose();
                }
                else {
                    if (data[0].error.includes('duplicate'))
                        toast.error("A top-up with the specified id already exists.");
                    else
                        toast.error("Sorry, we are unable to top-up at this time. Please try again later.");
                }
            }
        } catch (error) {
            toast.error("Sorry, we are unable to add top-up at this time. Please try again later.");
            await logger({ task: "Add top-up", error: error.toString() });
        }

        setIsloading(false);
    }

    const closeModal = () => {
        clear();
        onClose();
    }

    const clear = () => {
        setClient('');
        setAmount('');
    }

    const processForm = async (e) => {
        e.preventDefault();
        await topUp();
    }

    return (
        <>
            <Modal isCentered initialFocusRef={initialRef} closeOnOverlayClick={false} isOpen={isOpen} onClose={closeModal}>
                <ModalOverlay />
                <ModalContent>
                    <form onSubmit={processForm}>
                        <ModalHeader>Top up</ModalHeader>
                        <ModalCloseButton />
                        <ModalBody pb={2} >
                            <div style={{ overflow: 'auto', maxHeight: '60vh' }}>
                                <FormControl isRequired mt={2}>
                                    <FormLabel>Select Client</FormLabel>
                                    <Select ref={initialRef} value={client} onChange={e => setClient(e.target.value)}>
                                        <option key='0' value={null}></option>
                                        {clients.map((c, k) => <option key={k + 1} value={c.agentId}>{c.agentName}</option>)}
                                    </Select>
                                </FormControl>

                                <FormControl isRequired mt={5}>
                                    <FormLabel>Amount</FormLabel>
                                    <NumberInput size='md' value={amount} onChange={v => setAmount(v)}>
                                        <NumberInputField />
                                        <NumberInputStepper>
                                            <NumberIncrementStepper />
                                            <NumberDecrementStepper />
                                        </NumberInputStepper>
                                    </NumberInput>
                                </FormControl>
                            </div>
                        </ModalBody>

                        <ModalFooter>
                            <Stack direction={'row'}>
                                <Button onClick={closeModal}>Cancel</Button>
                                <Button isLoading={isLoading} type="submit" bgColor='#0C7FE9' color='white' _hover={{
                                    bg: "#3c98ed"
                                }} mr={3}>
                                    Top up
                                </Button>
                            </Stack>
                        </ModalFooter>
                    </form>
                </ModalContent>
            </Modal>
            <ToastContainer />
        </>
    )
}